import { Component, Prop, Ref, Vue, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { Logger } from 'fsts';
import { SearchParams } from '@/shared/model/searchParams';
import lieferantenSearchData, {
  LieferantenFacetSearchData,
  LieferantenSearchData,
} from '@/shared/model/smallPayloadModels/lieferantenSearchData';
import DateField from '@/components/_common/date-field/DateField.vue';

const logger = new Logger('search-form');
const authModule = namespace('auth');
const tblLieferantenModule = namespace('tblLieferanten');
const tblUpdateSupplierModule = namespace('tblUpdateSupplier');

@Component({
  components: { DateField },
})
export default class SearchFormKollegenauslieferung extends Vue {
  @Ref('deliverAbroadCombobx')
  private refDeliverAbroadCombobx!: any;
  @Ref('statusesCombobox')
  private refStatusesCombobox!: any;
  @Ref('membersCombobox')
  private refMembersCombobox!: any;

  @Ref('titlesCombobox')
  private refTitlesCombobox!: any;

  @tblLieferantenModule.Action('getZrNumberList')
  private actionGetZrNumberList!: any;

  @tblLieferantenModule.Action('getStatusCompaniesList')
  private actionGetStatusCompaniesList!: any;

  @tblLieferantenModule.Action('updateLieferantenSearchData')
  private actionUpdateLieferantenSearchData!: any;

  @tblLieferantenModule.Getter('getLieferantensSearchParams')
  private getLieferantensSearchParams!: any;

  @tblLieferantenModule.Getter('getLieferantenSearchData')
  private getLieferantenSearchData!: any;

  @tblLieferantenModule.Getter('isLieferantenSearchDataEmpty')
  private isLieferantenSearchDataEmpty!: any;

  @tblLieferantenModule.Action('getHauptwarengruppenList')
  private actionGetCompanyWrGruppen!: any;

  @authModule.Getter('azureUserEmail')
  private azureEmail!: any;

  listZrNumber = [];
  listStatusCompanies = [];
  private selectedStatus: string = '';
  lieferantenSearchData = lieferantenSearchData.defaultData();
  companyWrGruppen = [];
  private isLoadingFilters: any = {
    companyWrGruppen: false,
    listZrNumber: false,
    listStatusCompanies: false,
  };
  // state snapshots (store information about the conditions under which the list was last loaded)
  private lastFetchSnapshots: {
    facetSearch: SearchParams['andClauseFieldsIds'] | null;
    companyWrGruppen: string | null;
    listZrNumber: string | null;
    listStatusCompanies: string | null;
  } = {
    facetSearch: null, // или []
    companyWrGruppen: null,
    listZrNumber: null,
    listStatusCompanies: null,
  };

  created() {
    if (!this.getLieferantensSearchParams) {
      this.getLieferantensSearchParams = lieferantenSearchData.defaultData();
    }
    this.lieferantenSearchData = this.getLieferantenSearchData;
  }

  async mounted() {
    var promiseAll = [];
    promiseAll.push(this.getZrNumberList(), this.getStatusCompaniesList(), this.getCompanyZrsFromBackend());
  }

  isSearchDataWasCleared = false;
  @Watch('isLieferantenSearchDataEmpty', { deep: true })
  public async onIsLieferantenSearchDataEmpty(newVal: boolean, oldVal: boolean) {
    if (newVal == true) {
      this.isSearchDataWasCleared = true; // avoid eternal loop on clearing `searchData` (watcher glitch without this variable)
      this.lieferantenSearchData = lieferantenSearchData.defaultData();
    }
  }

  @Watch('lieferantenSearchData', { deep: true })
  public async onOptionsFilterChanged(newVal: LieferantenSearchData, oldVal: LieferantenSearchData) {
    // avoid loop when `searchData` was reset
    if (!this.isSearchDataWasCleared) {
      let payload = Object.assign({}, this.getLieferantenSearchData);
      payload.zrNumbersId = this.lieferantenSearchData.zrNumbersId;
      payload.statusCompanies = this.lieferantenSearchData.statusCompanies;
      payload.companiesWrGruppen = this.lieferantenSearchData.companiesWrGruppen;
      payload.searchFacetFields = this.getLieferantensSearchParams.andClauseFieldsIds;

      this.actionUpdateLieferantenSearchData(payload);
    }
    this.isSearchDataWasCleared = false;
  }

  private loadingMembers = false;
  private async getZrNumberList() {
    this.lieferantenSearchData.searchFacetFields = this.getLieferantensSearchParams.andClauseFieldsIds;
    this.actionGetZrNumberList({ lieferantenSearchData: this.lieferantenSearchData })
      .then((result: any) => {
        this.listZrNumber = result;
      })
      .catch((err: any) => {
        logger.error(err);
      })
      .finally(() => {
        this.isLoadingFilters['listZrNumber'] = false;
      });
  }

  private async getStatusCompaniesList() {
    this.lieferantenSearchData.searchFacetFields = this.getLieferantensSearchParams.andClauseFieldsIds;
    this.actionGetStatusCompaniesList({ lieferantenSearchData: this.lieferantenSearchData })
      .then((result: any) => {
        this.listStatusCompanies = result;
      })
      .catch((err: any) => {
        logger.error(err);
      })
      .finally(() => {
        this.isLoadingFilters['listStatusCompanies'] = false;
      });
  }

  showMenu() {
    this.refDeliverAbroadCombobx.activateMenu();
  }

  reloadRechnungsnummersList: boolean = false;
  reloadStatusesList: boolean = false;
  reloadMembersList: boolean = false;
  reloadSuppliersList: boolean = false;

  //#endregion

  searchRechnungsnummerInput = '';
  searchStatusInput = '';
  searchMembersInput = '';
  searchTitlesInput = '';
  searchModelNameInput = '';
  searchSupplierInput = '';

  clearSearchInput() {
    this.searchRechnungsnummerInput = '';
    this.searchStatusInput = '';
    this.searchMembersInput = '';
    this.searchTitlesInput = '';
    this.searchModelNameInput = '';
    this.searchSupplierInput = '';
  }

  // clearSearchFormData() {
  //   this.actionResetwochenabschluesseSearchFormData();
  // }

  private allowedDates(date: string) {
    const dateValue = new Date(date);
    let isFriday = dateValue.getDay() === 5;
    const today = new Date();
    let twoWeeksFromToday = new Date(today.getTime() + 12096e5 - 864e5); // `12096e5` is 14 days in milliseconds // (GSP-098) use 13 days (not 14) for 2 weeks after to be able to select again the Friday that 2 weeks from current Friday (otherwise it will be selected by default but you could not select it again manually)
    //`864e5` = 86400000 is 1 day in milliseconds

    if (this.isTodayMondayOrTuesday()) {
      twoWeeksFromToday = new Date(today.getTime() + 6048e5); // add 7 days in milliseconds to make next Friday valid (in 11 or 10 days (from Mon and Tue), not in 18 and 17 days as was before)
    }

    const isDateMoreThan2Weeks = dateValue > twoWeeksFromToday;

    return isFriday; // && isDateMoreThan2Weeks;
  }

  private isTodayMondayOrTuesday() {
    const today = new Date();
    const isMondayOrTuesday = today.getDay() === 1 || today.getDay() == 2;
    return isMondayOrTuesday;
  }

  activeState = [
    {
      text: this.$i18n.t(`select_all`), //'Alle',
      value: 'all',
    },
    {
      text: this.$i18n.t(`select_true`), //'Offen',
      value: 'true',
    },
    {
      text: this.$i18n.t(`select_false`), //'Erledigt',
      value: 'false',
    },
  ];

  changeSelectDeliverIsland() {
    //this.getTblUpdateConditions();
  }

  changeSelectDeliveryColleague() {
    //this.getTblUpdateConditions();
  }

  changeSelectDeliverAbroad() {
    // if (this.kollegenauslieferungSearchData.deliver_abroad == null) {
    //   this.kollegenauslieferungSearchData.deliver_abroad='all';
    //   this.refDeliverAbroadCombobx.activateMenu();
    // }
  }

  private async getCompanyZrsFromBackend() {
    this.lieferantenSearchData.searchFacetFields = this.getLieferantensSearchParams.andClauseFieldsIds;
    await this.actionGetCompanyWrGruppen({ lieferantenSearchData: this.lieferantenSearchData })
      .then((result: any) => {
        this.companyWrGruppen = result;
      })
      .catch((err: any) => {})
      .finally(() => {
        this.isLoadingFilters['companyWrGruppen'] = false;
      });
  }

  getDependencySnapshot(excludeFilterName: 'companyWrGruppen' | 'listZrNumber' | 'listStatusCompanies'): string {
    const state = {
      facetSearch: this.getLieferantensSearchParams?.andClauseFieldsIds,
      companyWrGruppen:
        excludeFilterName === 'companyWrGruppen' ? [] : [...this.lieferantenSearchData.companiesWrGruppen].sort(),
      listZrNumber: excludeFilterName === 'listZrNumber' ? [] : [...this.lieferantenSearchData.zrNumbersId].sort(),
      listStatusCompanies:
        excludeFilterName === 'listStatusCompanies' ? [] : [...this.lieferantenSearchData.statusCompanies].sort(),
    };
    return JSON.stringify(state);
  }

  async onFocusFilter(filterName: 'companyWrGruppen' | 'listZrNumber' | 'listStatusCompanies') {
    // ds, 13.05.2026 -> creating a snapshot of the current dependencies
    const currentSnapshot = this.getDependencySnapshot(filterName);
    // ds, 13.05.2026 -> if the snapshot hasn't changed since the last download, exit; no request is needed
    if (this.lastFetchSnapshots[filterName] === currentSnapshot) {
      return;
    }

    this.isLoadingFilters[filterName] = true;

    try {
      // ds, 13.05.2026 -> update only the list that the user has currently opened
      if (filterName === 'companyWrGruppen') {
        this.getCompanyZrsFromBackend();
      } else if (filterName === 'listZrNumber') {
        this.getZrNumberList();
      } else if (filterName === 'listStatusCompanies') {
        this.getStatusCompaniesList();
      }

      // ds, 13.05.2026 -> save the new snapshot
      this.lastFetchSnapshots[filterName] = currentSnapshot;
    } catch (error) {}
  }
}
